import React from 'react'

function FormSelect({options, value, field, handleChange, className, placeholder}) {
  return (
    <select
      value={value}
      onChange={(e) => {
        e.preventDefault();
        handleChange(field, e.target.value);
      }}
      className={className}
    >
      {placeholder && <option disabled value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default FormSelect;
